export enum CookieNames {
  IterableEmailCampaignId = 'iterableEmailCampaignId',
  UserIp = 'userIp',
  IterableTemplateId = 'iterableTemplateId',
  IterableMessageId = 'iterableMessageId',
  HomepageExperiment = 'homepage-experiment',
  Referrer = 'referrer',
}
